/**
 * Created by work on 17/6/15.
 */
import {REFRESH_PATCH_ITEMDATA} from
  '../actions/patchReport';

const initState = {
  patchItemData: null
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_PATCH_ITEMDATA: {
      const {patchItemData} = action;
      return Object.assign({}, state, {patchItemData});
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/patchItemData.js